import React from 'react';
import FlexionChart from './FlexionChart';

export default function AnkleAngleChart({ timeSeriesData, height = "400px" }) {
  if (!timeSeriesData || timeSeriesData.length === 0) {
    return null; // Don't render anything if no data
  }

  return (
    <FlexionChart
      title="Ankle Deflection Analysis (Normalized)"
      timeSeriesData={timeSeriesData}
      leftDataKey="left_ankle_deflection_norm"
      rightDataKey="right_ankle_deflection_norm"
      height={height}
      yAxisLabel="Ankle Deflection (degrees)"
      leftColor="#607D8B"
      rightColor="#795548"
    />
  );
}
